// components/TransactionsBullet.tsx
import React from "react";
import { Box } from "@mantine/core";
import {
  IconUser,
  IconArrowUpRight,
  IconArrowDownRight,
} from "@tabler/icons-react";

export const BULLET_SIZE = 40;
export const BADGE_SIZE = 20;
export const BADGE_INSET = -3;
export const MAIN_ARROW_ICON_SIZE = 18;
export const BADGE_ARROW_ICON_SIZE = 12;

export type BulletColor = "gray" | "blue";

export interface TransactionsBulletProps {
  imgSrc?: string | null;
  bg: string;
  centerIcon?: React.ReactNode;
  badgeColor: BulletColor;
  withBadge?: boolean;
}

export function TransactionsBullet({
  imgSrc,
  bg,
  centerIcon,
  badgeColor,
  withBadge,
}: TransactionsBulletProps) {
  // Show the outer “body-colored” ring only for avatar bullets or blue bullets.
  const showRing = Boolean(imgSrc) || badgeColor === "blue";
  const bulletShadow = showRing
    ? "0 0 0 2px var(--mantine-color-body), 0 4px 14px rgba(0,0,0,.35)"
    : "0 4px 14px rgba(0,0,0,.25)";

  return (
    <Box
      style={{ position: "relative", width: BULLET_SIZE, height: BULLET_SIZE }}
    >
      <Box
        style={{
          position: "absolute",
          inset: 0,
          borderRadius: 9999,
          overflow: "hidden",
          background: "var(--mantine-color-body)",
          boxShadow: bulletShadow,
          display: "grid",
          placeItems: "center",
        }}
      >
        {imgSrc ? (
          <img
            src={imgSrc}
            alt=""
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        ) : (
          <Box
            style={{
              width: "100%",
              height: "100%",
              display: "grid",
              placeItems: "center",
              background: bg,
              color: "var(--mantine-color-gray-0)",
            }}
          >
            {centerIcon ?? <IconUser size={18} />}
          </Box>
        )}
      </Box>

      {withBadge && (
        <Box
          style={{
            position: "absolute",
            right: BADGE_INSET,
            bottom: BADGE_INSET,
            width: BADGE_SIZE,
            height: BADGE_SIZE,
            borderRadius: 9999,
            display: "grid",
            placeItems: "center",
            background: `var(--mantine-color-${badgeColor}-filled)`,
            color: `var(--mantine-color-${badgeColor}-filled-color)`,
            boxShadow: "0 0 0 2px var(--mantine-color-body)",
          }}
        >
          {badgeColor === "gray" ? (
            <IconArrowUpRight size={BADGE_ARROW_ICON_SIZE} />
          ) : (
            <IconArrowDownRight size={BADGE_ARROW_ICON_SIZE} />
          )}
        </Box>
      )}
    </Box>
  );
}
